module.exports = __webpack_public_path__ + "static/media/DSCF0231-53woiYgs.5cc71c3b.JPG";